<template>
<main class="container">
	<section>
		<h2>什么是金卡？</h2>
		<ul>
			<li>金卡是用于瓜分金库分红收益的凭证。持有金卡可以参与瓜分金库分红。</li>
		</ul>
	</section>
	<section>
		<h2>金卡的特性是？</h2>
		<ul>
			<li>持有金卡就可持续获得现金收益，越早持有收益就越多；</li>
			<li>金库结束时，最后兑换金卡者可获得金库池内的所有奖金；</li>
			<li>分红收益将实时存入余额账户。</li>
		</ul>
	</section>
</main>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
main {
	padding: 0.25rem 0.16rem;
}
h2 {
	font-size: 0.16rem;
	line-height: 0.16rem;
	color: #5c3f0a;
  padding: 0.1rem 0;
  font-weight:bold;
}
ul li {
	margin-bottom: 0.15rem;
	font-size: 0.15rem;
	color: #4a4a4a;
	list-style: none;
	line-height: 0.22rem;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: row;
}
ul li::before {
	content: "";
	margin-top: 0.06rem;
	margin-right: 0.08rem;
	padding: 0.04rem;
	border-radius: 50%;
	background: #d6ba8a;
}
</style>